export default "__VITE_PUBLIC_ASSET__7ebd17f7__"